import React, { useEffect, useState, useMemo, useCallback } from 'react';
import styles from './dashboard.module.scss';
import Header from '@src/components/header/Header';
import Footer from '@src/components/footer/Footer';
import {useHistory} from 'react-router-dom';
import {Program, UserRoleEnum} from '../../../types';
import Spinner from '@src/components/spinner/Spinner';
import {useIntercom} from 'react-use-intercom';
import { useAnalytics, Events } from '@src/hooks/useAnalytics';
import CourseModal from '../../super-admin/courses/add-modal/CourseModal';
import { useGetAllProgramsLazyQuery } from '@api/graphql-codegen';
import { IntercomCheckListID } from '@constants';
import { useUser } from '@hooks';
import UnitPrograms from '@src/components/unit-programs/UnitProgram';
import { logger } from '../../../utils/logger';
import FooterPage from '@src/components/footer-page/FooterPage';


function Dashboard() {

  const { boot, isOpen } = useIntercom();
  const history = useHistory();
  const { trackEvent } = useAnalytics();
  const [user] = useUser();
  const [showModal, setShowModal] = useState(false)
  const [course, setCourse] = useState<Program>()
  const [refreshing, setRefreshing] = useState(false)

  const [getAllPrograms, { data: coursesData, loading: coursesLoading}] = useGetAllProgramsLazyQuery({ fetchPolicy: 'network-only' })
  const isSuperAdmin = useMemo(() => user?.role && user.role === UserRoleEnum.SuperAdmin, [user?.role]);
  useEffect(() => {
    getAllPrograms();
  },[getAllPrograms])

  useEffect(() => {
    if (boot) {
      boot({
        customAttributes: {
          horizontal_padding: 25,
        },
      });
    }
  }, [boot]);

  useEffect(() => {
    if ((window as any).Intercom && isOpen) {
      (window as any).Intercom('startChecklist', IntercomCheckListID);
    }
  }, [isOpen]);

  useEffect(() => {
    if (user?.id && !isSuperAdmin) {
      trackEvent(Events.views.dashboard, {
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
    });
    }
  }, [trackEvent, isSuperAdmin, user]);

  const refresh = useCallback(async () => {
    try {
      setRefreshing(true)
      await getAllPrograms({ fetchPolicy: 'network-only' })
    } catch(err) {
      logger.error(err)
    } finally {
      setRefreshing(false)
    }
  }, [getAllPrograms])

  const handleDuplicate = (newId: string, name: string) => {
    const newCourse = {
      ...course,
      id: newId,
      name
    }
    history.push({ pathname: '/super/courses/customize', state: { program: newCourse } })
  }

  const handleDuplicateCourse = (course: Program) => {
    setShowModal(true)
    setCourse(course)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }
  return (
    <>
    <Header />
      <div className={styles.page}>
        {(coursesLoading && !refreshing) ? <div className={styles.spinner}><Spinner/></div> : <>
          <UnitPrograms courses={coursesData?.programs as any} handleDuplicateCourse={handleDuplicateCourse} refresh={refresh}/>
        </>}
        <FooterPage />
      </div>
      {/* <Footer/> */}
      <CourseModal open={showModal} onClose={handleCloseModal} onCustome={handleDuplicate} course={course}/>
    </>
  );
}

export default Dashboard;
